<template>
  <b-modal :id="id" size="lg" :title="$t('report.title.tooManyData')">
    <div class="wrapper p-2">
      <p v-html="$t('report.text.emailInfo')"></p>
      <b-form-group :label="$t('report.fields.emails')">
        <tag-input v-model="emails" :recipients="emailList"
      /></b-form-group>
      <span v-if="isSubmit && !validReqEmail" class="text-danger text-sm-italic">{{
        $t('global.validation.required')
      }}</span>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex align-items-center justify-content-center">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          @click="cancel"
        />
        <McButton variant="primary" :text="$t('global.action.send')" @click="handleSend" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import TagInput from '@/components/taginput/TagInput'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    recipients: {
      type: Array,
    },
  },
  mounted() {
    if (this.recipients.length > 0) {
      this.emailList = this.recipients
      this.emails = this.recipients
    }
  },
  components: {
    McButton,
    TagInput,
  },
  data() {
    return {
      emails: [],
      emailList: [],
      isSubmit: false,
    }
  },
  emits: ['submit-emails'],
  computed: {
    validReqEmail() {
      return this.emails.length > 0
    },
  },
  methods: {
    handleSend() {
      this.isSubmit = true
      const timeout = setTimeout(() => {
        this.isSubmit = false
      }, 3000)
      if (this.validReqEmail) {
        this.$emit('submit-emails', this.emails)
        clearTimeout(timeout)
      }
    },
    handleDownload() {
      this.isSubmit = false
      this.$emit('submit-emails', [])
    },
  },
}
</script>
